export default c=>c.filter(c=>!!c).join(' ')
